import Vue from 'vue'
import Router from 'vue-router'

//Pages
import Home from '../pages/Home/Home/Router'
import MinhaConta from '../pages/Inicio/MinhaConta/Router'
import Logs from '../pages/Logs/Logs/Router'

import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Router'
import Usuarios from '../pages/Admin/Usuarios/Router'

import Pokemons from '../pages/App/Pokemons/Router'
//import Golpes from '../pages/App/Golpes/Router'

import Redirect from '../pages/redirect/Index/Router'
import Acessar from '../pages/Login/Acessar/Router'
import Erro from '../pages/Erro/404/Router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		...Redirect,
		{
			path: '/',
			component: () => import('@/layouts/Default'),
			children: [
				...Home,
				...MinhaConta,
				...Logs,
				...GrupoDeAcesso,
				...Usuarios,
				...Pokemons,
				//...Golpes,
			]
		},
		...Acessar,
		...Erro,
	]
})